import { ACCProject } from "../model/ACCProject";
import { ACCProjectRequestAccess } from "../model/ACCProjectRequestAccess";
import { BankendDataConnectorProjectRolesJob } from "../model/backend/BankendDataConnectorProjectRolesJob";
import { FrontendACCDataConnectorRequest } from "../model/frontend/FrontendACCDataConnectorRequest";
import { FrontendACCProject } from "../model/frontend/FrontendACCProject";
import { Type } from "class-transformer";
import { Dictionary } from "vue-router/types/router";
import { BackendBIM360IssueCommentV2 } from "../model/backend/BackendBIM360IssueCommentV2";
import { BackendBIM360IssueV2 } from "../model/backend/BackendBIM360IssueV2";
import { BIM360Company } from "../model/BIM360Company";
import { BIM360Hub } from "../model/BIM360Hub";
import { BIM360Issue } from "../model/BIM360Issue";
import { BIM360IssueActivity } from "../model/BIM360IssueActivity";
import { BIM360IssueActivityV2 } from "../model/BIM360IssueActivityV2";
import { BIM360IssueAttributeDefinition } from "../model/BIM360IssueAttributeDefinition";
import { BIM360IssueComment } from "../model/BIM360IssueComment";
import { BIM360IssueRootCauseCategories } from "../model/BIM360IssueRootCauseV2";
import { NGIssueTypeV2 } from "../model/BIM360NGIssueTypeV2";
import { BIM360Project } from "../model/BIM360Project";
import { ForgeUser } from "../model/ForgeUser";
import { FrontendBIM360Hub } from "../model/frontend/FrontendBIM360Hub";
import { FrontendBIM360Issue } from "../model/frontend/FrontendBIM360Issue";
import { FrontendBIM360IssueComment } from "../model/frontend/FrontendBIM360IssueComment";
import { FrontendBIM360Modelset } from "../model/frontend/FrontendBIM360Modelset";
import { FrontendBIM360Project } from "../model/frontend/FrontendBIM360Project";
import { FrontendForgeUser } from "../model/frontend/FrontendForgeUser";
import { ProjectLocation } from "../model/ProjectLocation";
import { ProjectRole } from "../model/ProjectRole";
import {
    PaginationRequest,
    PaginationResponse
} from "../util/PaginationParameters";
import { BackendAutodeskDMFolder } from "./../model/backend/BackendAutodeskDmFolder";
import { ERegion } from "./../model/ERegion";
import { FrontendAutodeskDmFolder } from "./../model/frontend/FrontendAutodeskDmFolder";
import { FrontendUserLicense } from "./../model/frontend/FrontendUserLicense";

import { FrontendRegisteredWebhook } from "./../model/frontend/FrontendRegisteredWebhook";

import { Metadata, MetaDataHub } from "./../model/frontend/FrontendSettings";
import { BackendACCRole } from "@/model/backend/BackendACCRole";
import { ACCProjectProduct } from "./../model/ACCProjectProduct"
import { BIM360ProjectService } from "@/model/BIM360ProjectService";
import { ModuleItem } from "@/model/backend/BackendBIMProjectRolesJob";
import { BackendMetadataHub } from './../model/backend/BackendMassifLicensesJob';
import { ACCCompany } from "./../model/ACCCompany";
import { BackendBluebeamConnectSettings } from "../model/backend/BackendBluebeamConnectSettings";

export abstract class APIRequest {
    pagination!: PaginationRequest;
}

export class APIResponse {
    pagination!: PaginationResponse;
}

export class GetRegionsRequestURLQuery {
    public region!: ERegion; //us | emea
}

export class GetUserInfoRequest extends APIRequest { }

export class GetUserInfoResponse extends APIResponse {
    @Type(() => FrontendForgeUser)
    public user!: ForgeUser;
}

export class GetAccessibleHubsRequest extends APIRequest { }

export class GetAccessibleHubsResponse extends APIResponse {
    @Type(() => FrontendBIM360Hub)
    public accessibleHubs!: BIM360Hub[];
}

export class GetAutodeskDmFoldersRequest extends APIRequest {
    public urlParams!: GetAutodeskDmFoldersRequestUrlParams;
}

export class GetAutodeskDmFoldersRequestUrlParams {
    public projectID!: string;
    public hubID!: string;
}

export class GetAutodeskDmFoldersResponse extends APIResponse {
    @Type(() => FrontendAutodeskDmFolder)
    public autodeskDmFolders!: BackendAutodeskDMFolder[];
}

export class GetAutodeskDmFolderContentsRequest extends APIRequest {
    public urlParams!: GetAutodeskDmFolderContentsRequestUrlParams;
}

export class GetAutodeskDmFolderContentsRequestUrlParams {
    public projectID!: string;
    public folderURN!: string;
}

export class GetAutodeskDmFolderContentsResponse extends APIResponse {
    @Type(() => FrontendAutodeskDmFolder)
    public autodeskDmFolders!: BackendAutodeskDMFolder[];
}


export class GetHubProjectsRequestURLParams {
    public hubID!: string;
}

export class GetHubProjectsRequest extends APIRequest {
    @Type(() => GetHubProjectsRequestURLParams)
    public urlParams!: GetHubProjectsRequestURLParams;
}

export class GetHubProjectsResponse extends APIResponse {
    @Type(() => FrontendBIM360Project)
    public projects!: BIM360Project[];
}

export class GetCompaniesRequestURLParams {
    public projectID!: string;
    public hubID!: string;
}

export class GetCompaniesRequest extends APIRequest {
    @Type(() => GetCompaniesRequestURLParams)
    public urlParams!: GetCompaniesRequestURLParams;
    public urlQuery!: GetRegionsRequestURLQuery;
}

export class GetCompaniesResponse extends APIResponse {
    @Type(() => BIM360Company)
    public companies!: BIM360Company[];
}

export class GetACCCompaniesResponse extends APIResponse {
    @Type(() => ACCCompany)
    public companies!: ACCCompany[];
}

export class GetProjectUsersRequestURLParams {
    public projectID!: string;
}

export class GetProjectUsersRequest extends APIRequest {
    @Type(() => GetProjectUsersRequestURLParams)
    public urlParams!: GetProjectUsersRequestURLParams;
    public urlQuery!: GetRegionsRequestURLQuery;
}

export class GetProjectUsersResponse extends APIResponse {
    @Type(() => FrontendForgeUser)
    public users!: ForgeUser[];
}

export class GetHubUsersResponse extends APIResponse {
    @Type(() => FrontendForgeUser)
    public users!: ForgeUser[];
}

export class GetProjectRolesRequestURLParams {
    public projectID!: string;
    public hubID!: string;
}

export class GetProjectRolesRequest extends APIRequest {
    @Type(() => GetProjectRolesRequestURLParams)
    public urlParams!: GetProjectRolesRequestURLParams;
    public urlQuery!: GetRegionsRequestURLQuery;
}

export class GetProjectRolesResponse extends APIResponse {
    @Type(() => ProjectRole)
    public roles!: ProjectRole[];
}

export class GetProjectLocationsRequestURLParams {
    public containerID!: string;
}
export class GetProjectLocationsRequest extends APIRequest {
    @Type(() => GetProjectLocationsRequestURLParams)
    public urlParams!: GetProjectLocationsRequestURLParams;
    public projectID!: string;
    public hubID!: string;
}
export class GetProjectLocationsResponse extends APIResponse {
    @Type(() => ProjectLocation)
    public locations!: ProjectLocation[];
}
export class GetProjectNGIssueTypesRequestURLParams {
    public containerID!: string;
}

export class GetProjectNGIssueTypesRequest extends APIRequest {
    @Type(() => GetProjectNGIssueTypesRequestURLParams)
    public urlParams!: GetProjectNGIssueTypesRequestURLParams;
}

export class GetProjectNGIssueTypesResponse extends APIResponse {
    @Type(() => NGIssueTypeV2)
    public nGIssueTypes!: NGIssueTypeV2[];
    public nGIssueTypesDict!: Dictionary<NGIssueTypeV2>;
}

export class GetProjectIssueRootCausesRequestURLParams {
    public containerID!: string;
}

export class GetProjectIssueRootCausesRequest extends APIRequest {
    @Type(() => GetProjectIssueRootCausesRequestURLParams)
    public urlParams!: GetProjectIssueRootCausesRequestURLParams;
}

export class GetProjectIssueRootCausesResponse extends APIResponse {
    @Type(() => BIM360IssueRootCauseCategories)
    public rootCauseCategories!: BIM360IssueRootCauseCategories[];
}


export class GetIssueAttributeDefinitionsRequestURLParams {
    public hubID!: string;
    public containerID!: string;
}

export class GetIssueAttributeDefinitionsRequest extends APIRequest {
    @Type(() => GetIssueAttributeDefinitionsRequestURLParams)
    public urlParams!: GetIssueAttributeDefinitionsRequestURLParams;
}

export class GetIssueAttributeDefinitionsResponse extends APIResponse {
    @Type(() => BIM360IssueAttributeDefinition)
    public issueAttributeDefinitions!: BIM360IssueAttributeDefinition[];
}


export class GetModelSetsRequestURLParams {
    public projectID!: string;
}

export class GetModelSetsRequest extends APIRequest {
    @Type(() => GetModelSetsRequestURLParams)
    public urlParams!: GetModelSetsRequestURLParams;
}

export class GetModelSetsResponse extends APIResponse {
    @Type(() => FrontendBIM360Modelset)
    public modelSets!: FrontendBIM360Modelset[];
}


export class PatchModelSetRequestURLParams {
    public projectID!: string;
    public modelsetID!: string;
}

export class PatchModelSetRequest extends APIRequest {
    @Type(() => PatchModelSetRequestURLParams)
    public urlParams!: PatchModelSetRequestURLParams;
    public body!: PatchModelSetRequestBody;
}

export class PatchModelSetRequestBody {
    @Type(() => FrontendBIM360Modelset)
    public modelset!: FrontendBIM360Modelset;
}

export class PatchModelSetResponse extends APIResponse { }


export class PostProjectIssueRequestURLParams {
    public containerID!: string;
}

export class PostProjectIssueRequestBody {
    @Type(() => FrontendBIM360Issue)
    public issue!: FrontendBIM360Issue;
}

export class PostProjectIssueRequest extends APIRequest {
    @Type(() => GetProjectIssueRootCausesRequestURLParams)
    public urlParams!: PostProjectIssueRequestURLParams;

    @Type(() => PostProjectIssueRequestBody)
    public body!: PostProjectIssueRequestBody;
}

export class PostProjectIssueResponse extends APIResponse {
    @Type(() => BackendBIM360IssueV2)
    public issue!: BackendBIM360IssueV2;
}

export class GetProjectIssuesRequestURLParams {
    public issueContainerID!: string;
}

export class GetProjectIssuesRequest extends APIRequest {
    @Type(() => GetProjectIssuesRequestURLParams)
    public urlParams!: GetProjectIssuesRequestURLParams;
}

export class GetProjectIssuesResponse extends APIResponse {
    @Type(() => FrontendBIM360Issue)
    public issues!: FrontendBIM360Issue[];
}

export class PatchProjectIssueRequestURLParams {
    public containerID!: string;
    public issueID!: string;
}

export class PatchProjectIssueRequestBody {
    // public name!: string;
    // public type!: string;

    @Type(() => FrontendBIM360Issue)
    public issue!: FrontendBIM360Issue;
}

export class PatchProjectIssueRequest extends APIRequest {
    @Type(() => PatchProjectIssueRequestURLParams)
    public urlParams!: PatchProjectIssueRequestURLParams;

    @Type(() => PatchProjectIssueRequestBody)
    public body!: PatchProjectIssueRequestBody;
}

export class PatchProjectIssueResponse extends APIResponse {
    @Type(() => FrontendBIM360Issue)
    public issue!: BIM360Issue;
}


export class GetIssueActivitiesRequestURLParams {
    public containerID!: string;
    public issueID!: string;
}

export class GetIssueActivitiesRequest extends APIRequest {
    @Type(() => GetIssueActivitiesRequestURLParams)
    public urlParams!: GetIssueActivitiesRequestURLParams;
}

export class GetIssueActivitiesResponse extends APIResponse {
    @Type(() => BIM360IssueActivity)
    public activities!: BIM360IssueActivity[];
}


export class GetIssueActivitiesV2Response extends APIResponse {
    @Type(() => BIM360IssueActivityV2)
    public activities!: BIM360IssueActivityV2[];
}


export class PostIssueCommentRequestBody {
    // public name!: string;
    // public type!: string;

    @Type(() => FrontendBIM360IssueComment)
    public comment!: FrontendBIM360IssueComment;
}

export class PostIssueCommentRequestURLParams {
    public containerID!: string;
}

export class PostIssueCommentRequest extends APIRequest {
    @Type(() => PostIssueCommentRequestURLParams)
    public urlParams!: PostIssueCommentRequestURLParams;
    @Type(() => PostIssueCommentRequestBody)
    public body!: PostIssueCommentRequestBody;
}

export class PostIssueCommentResponse extends APIResponse {
    @Type(() => BIM360IssueComment)
    public comment!: BIM360IssueComment;
}

export class GetIssueCommentsRequestURLParams {
    public containerID!: string;
    public issueID!: string;
}

export class GetIssueCommentsRequest extends APIRequest {
    @Type(() => GetIssueCommentsRequestURLParams)
    public urlParams!: GetIssueCommentsRequestURLParams;
}

export class GetIssueCommentsResponse extends APIResponse {
    @Type(() => BackendBIM360IssueCommentV2)
    public comments!: BackendBIM360IssueCommentV2[];
}

export class GetHubRolesIntersectionRequestURLParams {
    public selectedProjectID!: string;
    public selectedHubID!: string;
}

export class GetHubRolesIntersectionRequest extends APIRequest {
    @Type(() => GetHubRolesIntersectionRequestURLParams)
    public urlParams!: GetHubRolesIntersectionRequestURLParams;
    public urlQuery!: GetRegionsRequestURLQuery;
}

export class GetHubRolesIntersectionResponse extends APIResponse {
    @Type(() => ProjectRole)
    public hubs!: BIM360Hub[];
}

export class GetUserEntitlementsRequestURLParams {
    public email!: string;
}

export class GetUserEntitlementsRequest extends APIRequest {
    @Type(() => GetUserEntitlementsRequestURLParams)
    public urlParams!: GetUserEntitlementsRequestURLParams;

    // @Type(() => PostProjectIssueRequestBody)
    // public body!: PostProjectIssueRequestBody;
}

export class GetUserEntitlementsResponse extends APIResponse {
    public licenses!: any[];
}

export class PutClientAssetMetadataRequestURLParams {
    public clientID!: string;
    public assetID!: string;
    public productCode!: string;
}

export class PutClientAssetMetadataRequestBody {
    public hubs!: MetaDataHub[];
}

export class PutClientAssetMetadataRequest extends APIRequest {
    @Type(() => PutClientAssetMetadataRequestURLParams)
    public urlParams!: PutClientAssetMetadataRequestURLParams;

    @Type(() => PutClientAssetMetadataRequestBody)
    public body!: PutClientAssetMetadataRequestBody;
}

export class PutClientAssetMetadataRequestV2 extends APIRequest {
    @Type(() => PutClientAssetMetadataRequestURLParams)
    public urlParams!: PutClientAssetMetadataRequestURLParams;

    @Type(() => PutClientAssetMetadataRequestBodyV2)
    public body!: PutClientAssetMetadataRequestBodyV2;
}

export class PutClientAssetMetadataRequestBodyV2 {
    public productCode!: string;
    public hubs!: any[];
}

export class GetClientAssetMetadataRequestV2 extends APIRequest {
    @Type(() => PutClientAssetMetadataRequestURLParams)
    public urlParams!: PutClientAssetMetadataRequestURLParams;
}

export class GetClientAssetMetadataResponseV2 extends APIResponse {
    public metadata!: any;
}

export class GetAllClientAssetMetadatasResponse extends APIResponse { 
    public clientAssetMetadatas!: any[]
}


export class PutClientAssetMetadataResponse extends APIResponse { }


export class GetUserAccessInfoRequestURLParams { }

export class GetUserAccessInfoRequest extends APIRequest {
    @Type(() => GetUserAccessInfoRequestURLParams)
    public urlParams!: GetUserAccessInfoRequestURLParams;
}

export class GetUserAccessInfoResponse extends APIResponse {
    public licenses!: FrontendUserLicense[];
}

export class RegisterWebhookScope {
    folder!: string;
}
export class RegisterWebhookRequestBody {
  callbackUrl!: string;
  autoReactivateHook!: boolean;
  scope!: RegisterWebhookScope;
  region!: ERegion;
  hookAttribute?: Record<string, any>;
  token?: string;
  filter?: string;
  massifClientId?: string;
  massifClientAssetId?: string;
}
export class RegisterWebhookRequest extends APIRequest {
  public headers!: Headers;
  public body!: RegisterWebhookRequestBody;
}
export class GetHubACCProjectsRequestURLParams {
  public accountID!: string;
  public projectID!: string;
}

export class GetHubACCProjectsRequest extends APIRequest {
  @Type(() => GetHubACCProjectsRequestURLParams)
  public urlParams!: GetHubACCProjectsRequestURLParams;
  public urlQuery!: GetRegionsRequestURLQuery;
}

export class GetHubACCProjectsResponse extends APIResponse {
  @Type(() => FrontendACCProject)
  public projects!: ACCProject[];
}

export class GetHubACCUserProjectsRequestURLParams {
  public accountID!: string;
}

export class GetHubACCUserProjectsRequest extends APIRequest {
  @Type(() => GetHubACCUserProjectsRequestURLParams)
  public urlParams!: GetHubACCUserProjectsRequestURLParams;
  public urlQuery!: GetRegionsRequestURLQuery;
}

export class GetHubACCUserProjectsResponse extends APIResponse {
  @Type(() => FrontendACCProject)
  public projects!: ACCProject[];
}

export class PostACCProjectRequestAccessURLParams {
  public accountID!: string;
}
export class PostACCProjectRequestAccessRequest extends APIRequest {
  @Type(() => PostACCProjectRequestAccessURLParams)
  public urlParams!: PostACCProjectRequestAccessURLParams;
  @Type(() => ACCProjectRequestAccess)
  public body!: ACCProjectRequestAccess;
}
export class PostACCProjectRequestAccessResponse extends APIResponse {
  public message!: string;
}
export class PostACCDataConnectorRequestsResponse extends APIResponse {
  public request!: FrontendACCDataConnectorRequest;
}

export class PostACCDataConnectorProjectRolesJobURLParams {
  public accountID!: string;
}
export class PostACCDataConnectorProjectRolesJobRequest extends APIRequest {
  @Type(() => PostACCDataConnectorProjectRolesJobURLParams)
  public urlParams!: PostACCDataConnectorProjectRolesJobURLParams;
  public body!: {
    massifClientID: string;
    massifClientAssetID: string;
  };
}

export class PostACCDataConnectorProjectRolesJobResponse extends APIResponse {
  public job!: BankendDataConnectorProjectRolesJob;
}

export class RegisterWebhookResponse extends APIResponse {
  public status!: number;
  public message!: string;
}

export class DeleteWebhookRequestURLParams {
  public hookId!: string;
}
export class DeleteWebhookRequest extends APIRequest {
  @Type(() => DeleteWebhookRequestURLParams)
  public urlParams!: DeleteWebhookRequestURLParams;
  public region!: ERegion;
}
export class DeleteWebhookResponse extends APIResponse {
  public status!: number;
  public message!: string;
}

export class GetRegisteredWebhooksRequest extends APIRequest {
  public headers!: Record<string, string>;
  public region!: ERegion;
}

export class GetRegisteredWebhooksResponse extends APIResponse {
    public registeredWebhooks!: FrontendRegisteredWebhook[];
}

// Sharepoint sites
export class GetSPSitesRequestURLParams { }
export class GetSPSitesRequest extends APIRequest {
    @Type(() => GetSPSitesRequestURLParams)
    public urlParams!: GetSPSitesRequestURLParams;
}
export class GetSPSitesResponse extends APIResponse {
    public sites: any;
}

// Sharepoint Folders
export class GetSPFoldersRequestURLParams { }
export class GetSPFoldersRequest extends APIRequest {
    @Type(() => GetSPFoldersRequestURLParams)
    public urlParams!: GetSPFoldersRequestURLParams;
}

export class GetSPFoldersResponse extends APIResponse {
    public folders: any;
}


// Sharepoint Drives
export class GetSPDrivesRequestURLParams {
    siteId: string = "";
}
export class GetSPDrivesRequest extends APIRequest {
    @Type(() => GetSPDrivesRequestURLParams)
    public urlParams!: GetSPDrivesRequestURLParams;
}
export class GetSPDrivesResponse extends APIResponse {
    public drives: any;
}


// Sharepoint file upload
export class UploadFileToSPDriveRequestURLParams {
    driveId: string = "";
}
export class UploadFileToSPDriveResponse extends APIResponse {
    public status: string = "";
}

export class UploadFileToSPDriveRequestBody {
    formData!: FormData;
}

export class UploadFileToSPDriveRequest extends APIRequest {
    @Type(() => UploadFileToSPDriveRequestURLParams)
    public urlParams!: UploadFileToSPDriveRequestURLParams;
    public headers!: Headers;
    public file!: File;

    @Type(() => UploadFileToSPDriveRequestBody)
    public body!: UploadFileToSPDriveRequestBody;
}


export class GetFileLocationResponse extends APIResponse {
    public location: string = "";
}

export class GetFileLinkResponse extends APIResponse {
    public url: string = "";
}


export class ProcessFileSyncResponse extends APIResponse {
    status!: string;
}

export class ProcessFileSyncRequest extends APIRequest {
    @Type(() => ProcessFileSyncInfo)
    fileInfo!: ProcessFileSyncInfo;
    body!: any;
}

export class ProcessFileSyncInfo {
  lineageUrn: string = "";
  ext: string = "";
  fileName: string = "";
  projectId: string = "";
  msTenantId: string = "";
  sharepointSiteId: string = "";
  sharepointDriveId: string = "";
  region: ERegion = ERegion.US;
}

export class GetACCProjectRolesListRequestURLParams {
    public accountID!: string;
    public projectID!: string;
}

export class GetACCProjectRolesListRequest extends APIRequest {
    @Type(() => GetACCProjectRolesListRequestURLParams)
    public urlParams!: GetACCProjectRolesListRequestURLParams;
}

export class GetACCProjectRolesListResponse extends APIResponse {
    public accProjectRolesList!: BackendACCRole[];
}

export class PostACCProjectUserRequestURLParams {
    public accountID!: string;
    public projectID!: string;
}

export class PostACCProjectUserRequestBody {
    public email!: string;
    public companyID!: string;
    public roleIds!: string[];
    public products!: ACCProjectProduct[];
    public region!: ERegion;
}

export class PostACCProjectUserRequest extends APIRequest {
    @Type(() => PostACCProjectUserRequestURLParams)
    public urlParams!: PostACCProjectUserRequestURLParams;
    public body!: PostACCProjectUserRequestBody
}

export class PostACCProjectUserResponse extends APIResponse {
    public user!: {
        email: string;
        id: string;
        name: string;
        autodeskId: string;
        companyId: string;
        roleIds: string[];
        products: {};
        accessLevels: {};
    };
}    

export class PatchACCProjectUserResponse extends APIResponse {
    public user!: {
        email: string;
        id: string;
        companyId: string;
        roleIds: string[];
        products: [];
    };
}

export class PostBIM360ProjectUserRequestURLParams {
    public accountID!: string;
    public projectID!: string;
}

export class PostBIM360ProjectUserRequestBody {
    public email!: string;
    public companyID!: string;
    public industry_roles!: string[];
    public services!: BIM360ProjectService[];
    public region!: ERegion;
}

export class PostBIM360ProjectUserRequest extends APIRequest {
    @Type(() => PostACCProjectUserRequestURLParams)
    public urlParams!: PostBIM360ProjectUserRequestURLParams;
    public body!: PostBIM360ProjectUserRequestBody
}

export class PostBIM360ProjectUserResponse extends APIResponse {
    public user!: {
        email: string;
        user_id: string;
        project_id: string;
        account_id: string;
        company_id: string;
        industry_roles: string[];
        services: {};
    };
}

export interface AccUserImportRow {
  "Action": "Add" | "Update" | "Delete";
  "First Name": string;
  "Last Name": string;
  "Company": string;
  "Email": string;
  "Project Number": string;
  "Project Admin (YES/NO)": string;
  "Docs (YES/NO)": string;
  "Design Collaboration (YES/NO)": string;
  "Model Coordination (YES/NO)": string;
  "Build (YES/NO)": string;
  "Cost Management (YES/NO)": string;
  "Takeoff (YES/NO)": string;
  "Insights (YES/NO)": string;
  "Default Role / Role 1"?: string;
  "Role 2"?: string;
  "Role 3"?: string;
  "Role 4"?: string;
  "Role 5"?: string;
}

export class PostAccProjectUsersBulkImportRequestBody {
  public users: Array<AccUserImportRow> = [];
}

export class PostAccProjectUsersBulkImportRequest extends APIRequest {
    @Type(() => PostACCProjectUserRequestURLParams)
    public urlParams!: PostBIM360ProjectUserRequestURLParams;
    public body!: PostAccProjectUsersBulkImportRequestBody;
    public urlQuery!: GetRegionsRequestURLQuery;
}

export class PostAccProjectUsersBulkImportResponse extends APIResponse {
    public jobIds!: string[];
}
export class PostAccProjectUsersImportResponse extends APIResponse {
    public jobId!: string;
}

export class GetMassifClientAssetsResponse extends APIResponse {
    public assets!: {
        _id: string,
        metadata: Metadata,
        users: string[]
    }[];
}

export class GetMassifClientAssetsResponseV2 extends APIResponse {
    public client_asset_id!: string;
    public client_id!: string;
    public metadata!: any;
    public is_active!: boolean;
}

export class GetUserModuleAccessRequestURLParams {
    public forgeID!: string;
}
export class GetUserModuleAccessRequest extends APIRequest {
    @Type(() => GetUserModuleAccessRequestURLParams)
    public urlParams!: GetUserModuleAccessRequestURLParams;
}

export class GetUserModuleAccessResponse extends APIResponse {
    public modules!: ModuleItem[]
}

export class GetUserPermissionForProjectAccessRequestURLParams {
    public forgeID!: string;
    public accountID!: string;
}
export class GetUserPermissionForProjectAccessRequest extends APIRequest {
    @Type(() => GetUserPermissionForProjectAccessRequestURLParams)
    public urlParams!: GetUserPermissionForProjectAccessRequestURLParams;
}
export class GetUserPermissionForProjectAccessResponse extends APIResponse {
    public isAdmin!: boolean;
}

export class GetProjectlistAccountSettingRequestURLParams {
    public accountID!: string;
}
export class GetProjectlistAccountSettingRequest extends APIRequest {
    @Type(() => GetProjectlistAccountSettingRequestURLParams)
    public urlParams!: GetProjectlistAccountSettingRequestURLParams;
}
export class GetProjectlistAccountSettingResponse extends APIResponse {
    public setting!: BackendMetadataHub;
}

export class PutBluebeamAccessCreateConnectionRequestURLParams {
    // public connectionId!: string;
}

export class PutBluebeamAccessCreateConnectionRequestBody {
    public projectName!: string;
    public webhookCallbackUrl!: string;
    public massifClientAssetId!: string;
    public massifClientId!: string;
    public connectionId!: string;
}

export class PutBluebeamAccessCreateConnectionRequest extends APIRequest {
    @Type(() => PutBluebeamAccessCreateConnectionRequestURLParams)
    public urlParams!: PutBluebeamAccessCreateConnectionRequestURLParams;
    @Type(() => PutBluebeamAccessCreateConnectionRequestBody)
    public body!: PutBluebeamAccessCreateConnectionRequestBody;
}

export class PutBluebeamAccessCreateConnectionResponse extends APIResponse {
    public status!: string;
}

export class GetBluebeamAccessConnectionTokensRequestURLParams {
    public vendor!: 'forma' | 'bluebeam';
    public connectionId!: string;
    public massifClientAssetId!: string;
}
export class GetBluebeamAccessConnectionTokensRequest extends APIRequest {
    @Type(() => GetBluebeamAccessConnectionTokensRequestURLParams)
    public urlParams!: GetBluebeamAccessConnectionTokensRequestURLParams;
}

export class GetBluebeamAccessConnectionTokensResponse extends APIResponse {
    public accessToken!: string;
    public refreshToken!: string;
}

export class DeleteBluebeamAccessConnectionRequestURLParams {
    public connectionId!: string;
    public massifClientAssetId!: string;
}
export class DeleteBluebeamAccessConnectionRequest extends APIRequest {
    @Type(() => DeleteBluebeamAccessConnectionRequestURLParams)
    public urlParams!: DeleteBluebeamAccessConnectionRequestURLParams;
}

export class DeleteBluebeamAccessConnectionResponse extends APIResponse {
    public status!: string;
}

export class GetBluebeamAccessConnectionRequestURLParams {
    public connectionId!: string;
    public massifClientAssetId!: string;
}
export class GetBluebeamAccessConnectionRequest extends APIRequest {
    @Type(() => GetBluebeamAccessConnectionRequestURLParams)
    public urlParams!: GetBluebeamAccessConnectionRequestURLParams;
}

export class GetBluebeamAccessConnectionResponse extends APIResponse {
    public connection!: any;
}


export class DeleteBluebeamAccessTokensRequestURLParams {
    public vendor!: 'forma' | 'bluebeam';
    public connectionId!: string;
    public massifClientAssetId!: string;
}
export class DeleteBluebeamAccessTokensRequest extends APIRequest {
    @Type(() => DeleteBluebeamAccessTokensRequestURLParams)
    public urlParams!: DeleteBluebeamAccessTokensRequestURLParams;
}

export class DeleteBluebeamAccessTokensResponse extends APIResponse {
    public status!: string;
}

export class GetHubUsersRequestURLParams {
  public accountID!: string;
}

export class GetHubUsersRequest extends APIRequest {
  @Type(() => GetHubUsersRequestURLParams)
  public urlParams!: GetHubUsersRequestURLParams;
  public urlQuery!: GetRegionsRequestURLQuery;
}

export class GetBluebeamAccessSettingsRequestURLParams {
  public hubID!: string;
}

export class GetBluebeamAccessSettingsRequest extends APIRequest {
  @Type(() => GetHubUsersRequestURLParams)
  public urlParams!: GetBluebeamAccessSettingsRequestURLParams;
}

export class GetBluebeamAccessSettingsResponse extends APIResponse {
    public settings!: BackendBluebeamConnectSettings[];
}